const initialState = {
  logisticsCost: [],
};

function LogisticsCostReducer(state = initialState, action) {
  if (action.type === "LOGISTICS_COST_LIST") {
    var logisticsCostDetails = {
      ...state,
      logisticsCost: action.payload,
    };
    return logisticsCostDetails;
  }

  return state;
}

export default LogisticsCostReducer;
